import * as React from 'react'

function AppleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={10}
      height={12}
      viewBox="0 0 10 11"
      {...props}
    >
      <path d="M8.336 10.559c-.64.578-1.352.488-2.031.218-.72-.28-1.375-.297-2.137 0-.945.375-1.45.266-2.02-.218-3.218-3.067-2.742-7.743.914-7.918.891.043 1.512.453 2.032.488.777-.149 1.52-.567 2.351-.512 1 .074 1.746.442 2.246 1.098-2.054 1.144-1.566 3.652.32 4.355-.378.918-.863 1.828-1.675 2.496zM5.023 2.605C4.926 1.242 6.121.121 7.493.012c.19 1.574-1.544 2.75-2.47 2.593zm0 0" />
    </svg>
  )
}

export default AppleIcon
